import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Sparkles, ShieldCheck, ArrowRight } from "lucide-react";
import { adminApi, adminAuth } from "@/admin/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const nav = useNavigate();

  if (adminAuth.isLoggedIn()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      adminAuth.setToken(data.token);
      toast.success(`Welcome, ${data.admin.email}`);
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-totem-bg grid place-items-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="grid place-items-center w-14 h-14 rounded-2xl bg-totem-surface border border-totem-border mb-3">
            <ShieldCheck size={26} className="text-totem-green" strokeWidth={2.2} />
          </div>
          <div className="mono uppercase text-[10px] tracking-[0.3em] text-totem-textDim">
            FPL Totem Admin
          </div>
          <h1 className="display-heading text-3xl text-totem-green mt-1">SIGN IN</h1>
        </div>

        <form onSubmit={submit} className="totem-card p-6 space-y-4">
          <div>
            <label htmlFor="ademail" className="label-caps block mb-2">Email</label>
            <input
              id="ademail"
              data-testid="admin-login-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-totem-surface border border-totem-border rounded-lg px-3 py-2.5 focus:outline-none focus:border-totem-green/60"
              required
            />
          </div>
          <div>
            <label htmlFor="adpw" className="label-caps block mb-2">Password</label>
            <input
              id="adpw"
              data-testid="admin-login-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-totem-surface border border-totem-border rounded-lg px-3 py-2.5 focus:outline-none focus:border-totem-green/60"
              required
            />
          </div>
          {error && (
            <div data-testid="admin-login-error" className="text-xs text-totem-red border border-totem-red/40 bg-totem-red/10 px-3 py-2 rounded">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full flex items-center justify-center gap-2 bg-totem-green text-totem-bg font-semibold rounded-lg py-3 hover:brightness-110 disabled:opacity-60 transition"
          >
            {loading ? "Signing in…" : "Sign in"}
            <ArrowRight size={16} strokeWidth={2.4} />
          </button>
        </form>

        <div className="mt-6 text-[11px] text-totem-textFaint mono text-center">
          Internal admin only. All actions are audited.
        </div>
      </div>
    </div>
  );
}
